import { Box } from '@mui/material';
import { translate } from '../../translations/translator';
import { isSafari } from 'react-device-detect';
const t = key => translate('worksheet', key);

export const LwtCopyrightDoubleLines = ({
  containerStyle = {},
  isNarrow = false,
  isWide = false,
  noFooterText = false,
  isLandscape = false,
  isExtraWide = false,
  addAveryText = false
}) => {
  let footerText = isNarrow ? t('3456Subtitle') : t('12Subtitle');
  if (isWide) footerText = t('kg1Subtitle');
  if (isExtraWide) footerText = t('preKSubtitle');

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '0px',
        left: '30px',
        width: '100%',
        minHeight: isSafari ? 'unset' : '11px',
        whiteSpace: 'nowrap',
        fontFamily: 'FF-HWTFuturaBook',
        fontSize: '10px',
        fontWeight: 'bold',
        ...containerStyle
      }}
    >
      {addAveryText ? (
        <Box>
          <Box
            sx={{
              display: 'flex',
              width: '400px',
              fontSize: '10px',
              fontWeight: 'bold',
              marginBottom: '-20px'
            }}
          >
            <p className="autoParaStyle1" style={{ paddingLeft: isLandscape ? 330 : 330 }}>
              {footerText}
            </p>
          </Box>
          <Box
            sx={{
              display: 'flex',
              width: '400px',
              fontSize: '10px',
              fontWeight: 'bold'
            }}
          >
            <p className="autoParaStyle1">&copy; 2026 Learning Without Tears</p>
            {!noFooterText && (
              <p
                className="autoParaStyle1"
                style={{ paddingLeft: isLandscape ? '330px' : '140px' }}
              >
                Avery 80506 Wraparound Address Labels
              </p>
            )}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            width: '400px',
            fontSize: '10px',
            fontWeight: 'bold'
          }}
        >
          <p className="autoParaStyle1">&copy; 2026 Learning Without Tears</p>
          {!noFooterText && (
            <p className="autoParaStyle1" style={{ paddingLeft: isLandscape ? '330px' : '200px' }}>
              {footerText}
            </p>
          )}
        </Box>
      )}
    </Box>
  );
};
